import React, { createContext, useState } from 'react';
import { createContextHook } from '../contextUtils';

// DownloadContext manages download states for various chart formats
const DownloadContext = createContext();

export function DownloadProvider({ children }) {
  // Controls initial chart download functionality
  const [initialDownloadFlag, setInitialDownloadFlag] = useState(false);
  // Controls comparison chart download functionality
  const [compareDownloadFlag, setCompareDownloadFlag] = useState(false);
  // Specifies the type of download (e.g., "png", "pdf", "csv")
  const [downloadType, setDownloadType] = useState("");
  // Controls PNG download for main map
  const [mapPngDownloadFlag, setMapPngDownloadFlag] = useState(false);
  // Controls PDF download for main map
  const [mapPdfDownloadFlag, setMapPdfDownloadFlag] = useState(false);
  // Controls PNG download for comparison map
  const [mapPngCompDownloadFlag, setMapPngCompDownloadFlag] = useState(false);
  // Controls PDF download for comparison map
  const [mapPdfCompDownloadFlag, setMapPdfCompDownloadFlag] = useState(false);

  const value = {
    downloadType, setDownloadType,
    initialDownloadFlag, setInitialDownloadFlag,
    compareDownloadFlag, setCompareDownloadFlag,
    mapPngDownloadFlag, setMapPngDownloadFlag,
    mapPdfDownloadFlag, setMapPdfDownloadFlag,
    mapPngCompDownloadFlag, setMapPngCompDownloadFlag,
    mapPdfCompDownloadFlag, setMapPdfCompDownloadFlag
  };

  return (
    <DownloadContext.Provider value={value}>
      {children}
    </DownloadContext.Provider>
  );
}

export const useDownload = createContextHook(DownloadContext, 'useDownload');